export const isValidUri = (url) => {
  if (typeof url !== 'string') {
    return false;
  }
  try {
    decodeURIComponent(url);
    return true;
  } catch {
    return false;
  }
};

export const validateUrl = (url, setErrorMessage) => {
  if (!isValidUri(url)) {
    setErrorMessage('Invalid URL');
    return false;
  }
  return true;
};

export const isSafeUrl = (url) => {
  const isSafe = /^https?:\/\//i.test(url);
  return isSafe;
};
